import React, { useContext } from 'react';
import { Message } from 'primereact/message';
import AuthContext from '../../components/AuthContext';
import { LocaleContext } from '../../components/LocaleContext';
import { hasCrmModuleCompleteList } from '../../utils/crmCommunicationPermissions';
import CrmCommunicationTicketsList from './CrmCommunicationTicketsList';
import { CRM_COMM_PAGE_ALL_ACQUISITION_BY_STATE } from '../../utils/crmCommunicationTableColumns';

export const CRM_COMM_MASK_ALL_ACQUISITION_BY_STATE = 'cust036';

/** Všetky akvizície → Podľa stavu (cust036). */
export default function CustomerAllAcquisitionByStateList(props) {
  const { user } = useContext(AuthContext);
  const { t } = useContext(LocaleContext);
  const canAccess = hasCrmModuleCompleteList(user) || !!user?.is_superuser;

  if (!canAccess) {
    return (
      <div className="p-4">
        <Message severity="warn" text={t('CustomerAllPartnersList.AccessDenied')} />
      </div>
    );
  }

  return (
    <CrmCommunicationTicketsList
      {...props}
      crmTicketsLayout
      stateListLayout
      types="acquisition"
      mineOnlyDefault={false}
      listPageKey={CRM_COMM_PAGE_ALL_ACQUISITION_BY_STATE}
      maskCode={CRM_COMM_MASK_ALL_ACQUISITION_BY_STATE}
    />
  );
}
